/**
 * @file Infoc上报
 * @author yuanliukai@cmcm.cm
 * @createDate 2020-11-10
 */
import { getParamStrByObj } from '../base'

// 发起请求
function createImg (url) {
  let img = new Image(0, 0)
  img.onload = function () {
    img = null
  }
  img.src = url
  if (img.complete) {
    img = null
  }
}

/**
 * @class Infoc
 * @desc Infoc类
 */
export class Infoc {
  /**
  * @constructor
  * @param {object} project 业务代称，用于向projectMap取值
  * @param {string} uuid 用户UUID
  */
  constructor (project, uuid) {
    if (typeof window === 'undefined' || !project || !uuid) {
      throw new Error('params error, project and uuid params are required!')
    }

    const isHttps = (window.location.protocol === 'https:')
    this.root = isHttps ? project.httpsUrl : project.httpUrl
    this.params = { ...project.params, uuid: uuid }
  }

  /**
  * @param {object} obj 上报的表单对象
  * @param {boolean} async 上报的方式，模式是异步上报
  */
  report (obj, async = true) {
    if (typeof obj !== 'object') {
      return
    }
    // 合并上报参数
    const reportParams = { ...this.params, ...obj }

    // 拼接上报url
    const url = `${this.root}?${getParamStrByObj(reportParams)}`

    // 默认异步
    if (async) {
      setTimeout(function () {
        createImg(url)
      }, 0)
    } else {
      createImg(url)
    }
  }
}
